import {
  loadCurrentDomainFailedAction,
  loadCurrentDomainSucceededAction,
  loadCurrentEntityTypeFailedAction,
  loadCurrentEntityTypeSucceededAction,
  loadCurrentModuleFailedAction,
  loadCurrentModuleSucceededAction, loadcurrentTaskDoNextTaskFailedAction, loadcurrentTaskDoNextTaskSucceedAction,
  loadcurrentTaskMatTableColumnDefsFailedAction,
  loadcurrentTaskMatTableColumnDefsSucceedAction,
  removeCurrentDomainSucceededAction,
  removeCurrentEntityTypeSucceededAction,
  removeCurrentModuleSucceededAction
} from '../action/current-context.action';
import {createReducer, on} from '@ngrx/store';
import { TaskDoNextTask } from '../../../models/task-do-next-task';
import { TaskDisplayedColumnsDef } from '../../../models/workflow/taskDisplayedColumnsDef';

export class CurrentContext {
  currentEntityType: string;
  currentDomain: string;
  currentModule: string;
  currentTaskMatTableColumnDefs?: TaskDisplayedColumnsDef;
  currentTaskDoNextTask?: TaskDoNextTask;
}

export class CurrentContextState {
  datas: CurrentContext;
  loading: boolean;
  error: any;
}

export const CURRENT_CONTEXT_INITIAL_STATE: CurrentContextState = {
  datas: {
    currentEntityType: null,
    currentDomain: null,
    currentModule: null,
    currentTaskMatTableColumnDefs:null,
    currentTaskDoNextTask: null
  },
  loading: false,
  error: null,
};



export const currentContextReducer = createReducer(
  // Initial State
  {
    datas: {
      currentEntityType: null,
      currentDomain: null,
      currentModule: null,
      currentTaskMatTableColumnDefs:null,
      currentTaskDoNextTask: null
    },
    loading: false,
    error: null,
  },

  // Load Succeeded Actions
  on(loadCurrentEntityTypeSucceededAction, (state, { payload }) => ({
    ...state,
    datas: {
      ...state.datas,
      currentEntityType: payload,
    },
    loading: false,
    error: null,
  })),

  on(loadCurrentDomainSucceededAction, (state, { payload }) => ({
    ...state,
    datas: {
      ...state.datas,
      currentDomain: payload,
    },
    loading: false,
    error: null,
  })),

  on(loadCurrentModuleSucceededAction, (state, { payload }) => ({
    ...state,
    datas: {
      ...state.datas,
      currentModule: payload,
    },
    loading: false,
    error: null,
  })),

  on(loadcurrentTaskMatTableColumnDefsSucceedAction, (state,{payload}) => ({
    ...state,
    datas: {
      ...state.datas,
      currentTaskMatTableColumnDefs: payload
    },
    loading: false,
    error: null,
  })),

    on(loadcurrentTaskDoNextTaskSucceedAction, (state,{payload}) => ({
      ...state,
      datas: {
        ...state.datas,
        currentTaskDoNextTask: payload
      },
      loading: false,
      error: null,
    })),
  // Load Failed Actions
  on(
    loadCurrentEntityTypeFailedAction,
    loadCurrentDomainFailedAction,
    loadCurrentModuleFailedAction,
    loadcurrentTaskMatTableColumnDefsFailedAction,
    loadcurrentTaskDoNextTaskFailedAction,
    (state) => ({
      ...state,
      loading: false,
      error: true,
    })
  ),

  // Remove Succeeded Actions
  on(removeCurrentEntityTypeSucceededAction, (state) => ({
    ...state,
    datas: {
      ...state.datas,
      currentEntityType: null,
    },
    loading: false,
    error: null,
  })),

  on(removeCurrentDomainSucceededAction, (state) => ({
    ...state,
    datas: {
      ...state.datas,
      currentDomain: null,
    },
    loading: false,
    error: null,
  })),

  on(removeCurrentModuleSucceededAction, (state) => ({
    ...state,
    datas: {
      ...state.datas,
      currentModule: null,
    },
    loading: false,
    error: null,
  }))
);
